var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasicOnboarding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 289,
    height: 215,
    viewBox: "0 0 289 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-a",
    d: "M0.6285,5.3865 C0.4793,2.6255 2.596,0.3874 5.3576,0.3874 L129.1133,0.3874 C131.8743,0.3874 133.9917,2.6227 133.8424,5.3865 L128.3028,107.92586 C128.1537,110.68679 125.7921,112.92496 123.0394,112.92496 L11.4315,112.92496 C8.6737,112.92496 6.3174,110.68964 6.168,107.92586 L0.6285,5.3865 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-c",
    d: "M0.7242,0.3874 L89.1133,0.3874 C91.8743,0.3874 93.9917,2.6227 93.8424,5.3865 L88.3028,107.92586 C88.2691,108.54935 88.1227,109.14617 87.8843,109.69659 C87.8445,109.26752 87.7263,108.81152 87.5229,108.33882 L43.0545,4.9735 C41.9632,2.4367 38.8471,0.3874 36.0908,0.3874 L0.7242,0.3874 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-e",
    points: "3.718 .936 7.347 .936 3.683 4.69 .055 4.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-g",
    points: "3.779 .936 7.408 .936 3.744 4.69 .116 4.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-i",
    points: "4.586 .936 8.25 4.69 4.621 4.69 .958 .936"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-k",
    points: "4.526 .936 8.189 4.69 4.562 4.69 .897 .936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-m",
    d: "M20.3506,8.3057 C20.9791,6.5711 21.4171,3.9293 21.5076,2.081 L27.9437,3.7025 C27.4296,11.3493 21.762,18.04687 13.3567,18.0441808 C3.8465,18.04094 0.171,9.6723 0.6654,3.3308 L3.4585,2.4312 C3.0034,6.0399 4.1083,8.6429 4.8694,9.8355 C3.963,4.7309 7.7695,0.5985 12.5355,0.595297578 C16.8225,0.5921 20.3671,3.7601 20.3506,8.3057 Z M7.3974,8.4662 C7.3974,11.346 9.7041,13.68021 12.5493,13.68021 C15.394,13.68021 17.6996,11.346 17.6996,8.4662 C17.6996,5.5869 15.394,3.2527 12.5493,3.2527 C9.7041,3.2527 7.3974,5.5869 7.3974,8.4662 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-o",
    d: "M1.4519,7.8967 C2.3504,3.5712 6.6539,0.0647 11.0867,0.0647 L139.7041,0.0647 C144.1268,0.0647 148.4407,3.5725 149.3389,7.8967 L149.8758,10.482 C150.7743,14.8075 147.9272,18.314 143.5065,18.314 L7.2843,18.314 C2.8682,18.314 0.0168,14.8061 0.915,10.482 L1.4519,7.8967 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-q",
    d: "M77.3391,7.8967 L77.876,10.482 C78.7742,14.8061 75.9238,18.314 71.509,18.314 L10.5523,18.314 L0.3648,0.0647 L67.7202,0.0647 C72.1289,0.0647 76.4406,3.5712 77.3391,7.8967 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-s",
    points: ".686 .698 59.785 .698 59.785 53.925 .686 53.925"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-u",
    points: ".478 .698 1.993 .698 1.993 53.925 .478 53.925"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-w",
    points: ".686 .698 38.57 .698 16.597 53.925 .686 53.925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-y",
    d: "M125.752613,60 L0.705037411,60 C2.75561245,26.8428668 29.9646333,0.59312 63.22883,0.59312 C96.4930267,0.59312 123.702038,26.8428668 125.752613,60 L125.752613,60 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-A",
    d: "M0.69925,12.83161 C0.69925,5.91203 6.30742,0.30261 13.22883,0.30261 C20.14872,0.30261 25.75841,5.9108 25.75841,12.83161 L25.75841,16.77108 C25.75841,23.69065 20.15025,29.30008 13.22883,29.30008 C6.30894,29.30008 0.69925,23.69189 0.69925,16.77108 L0.69925,12.83161 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-C",
    d: "M58.01877,116.38489 C26.19208,116.38489 0.39145,90.41968 0.39145,58.39 C0.39145,26.3603 26.19208,0.395 58.01877,0.395 C89.8455,0.395 115.6461,26.3603 115.6461,58.39 C115.6461,90.41968 89.8455,116.38489 58.01877,116.38489 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-E",
    d: "M142.8538,84.8109 C142.8538,101.19784 138.9398,116.49799 132.1626,129.46226 C116.0676,121.44254 101.9328,116.34378 71.59688,116.34402 C38.54299,116.34429 31.08331,123.13752 13.46164,133.80741 C5.1982,119.9758 0.33996,103.06784 0.33996,84.8109 C0.33996,38.0264 15.3516,0.1001 71.59688,0.1001 C127.8422,0.1001 142.8538,38.0264 142.8538,84.8109 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-G",
    d: "M58.01877,116.38489 C26.19208,116.38489 0.39145,90.41968 0.39145,58.39 C0.39145,26.3603 26.19208,0.395 58.01877,0.395 C89.8455,0.395 115.6461,26.3603 115.6461,58.39 C115.6461,90.41968 89.8455,116.38489 58.01877,116.38489 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-I",
    d: "M0.68451,6.2854 C8.33059,2.513 16.92891,0.395 26.01877,0.395 C57.8455,0.395 83.6461,26.3603 83.6461,58.39 C83.6461,84.34236 66.7074,106.31329 43.3492,113.71649 C62.4747,104.28056 75.6423,84.49377 75.6423,61.6119 C75.6423,29.5822 49.8417,3.617 18.01498,3.617 C11.97618,3.617 6.15434,4.5518 0.68451,6.2854 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-K",
    d: "M33.92544,42.6571 C12.10332,60.2803 9.48379,113.8292 7.41119,107.16338 C-12.645709,42.6571 15.77769,0.134 67.5819,0.134 C119.3861,0.134 137.1125,45.5044 132.1553,78.1211 C127.1982,110.73781 131.475,60.6923 72.96302,54.8872 C44.26371,52.0399 39.65135,38.033 33.92544,42.6571 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-M",
    d: "M6.83543,12.3106 C3.45099,12.3106 0.70736,9.6487 0.70736,6.3651 C0.70736,3.0815 3.45099,0.4197 6.83543,0.4197 C10.21987,0.4197 12.96351,3.0815 12.96351,6.3651 C12.96351,9.6487 10.21987,12.3106 6.83543,12.3106 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-O",
    d: "M6.83543,12.3106 C3.45099,12.3106 0.70736,9.6487 0.70736,6.3651 C0.70736,3.0815 3.45099,0.4197 6.83543,0.4197 C10.21987,0.4197 12.96351,3.0815 12.96351,6.3651 C12.96351,9.6487 10.21987,12.3106 6.83543,12.3106 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-Q",
    d: "M2.20823,2.8253 C1.44682,2.8253 0.82957,2.2265 0.82957,1.4878 C0.82957,0.749 1.44682,0.1502 2.20823,0.1502 C2.96964,0.1502 3.58688,0.749 3.58688,1.4878 C3.58688,2.2265 2.96964,2.8253 2.20823,2.8253 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-S",
    d: "M6.5834,12.751 C3.19892,12.751 0.45529,9.9906 0.45529,6.5853 C0.45529,3.1801 3.19892,0.4197 6.5834,0.4197 C9.9678,0.4197 12.7114,3.1801 12.7114,6.5853 C12.7114,9.9906 9.9678,12.751 6.5834,12.751 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-U",
    d: "M1.9562,3.0256 C1.1948,3.0256 0.5775,2.4045 0.5775,1.6384 C0.5775,0.8723 1.1948,0.2513 1.9562,0.2513 C2.7176,0.2513 3.3348,0.8723 3.3348,1.6384 C3.3348,2.4045 2.7176,3.0256 1.9562,3.0256 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-W",
    d: "M51.0055704,67 L0.513784525,67 C0.509218139,66.8872511 0.523410945,66.7714139 0.5586,66.656322 L20.5948,1.12073 C20.7603,0.5794 21.3372,0.27593 21.8815,0.44232 L66.1383,13.973 C66.6834,14.13965 66.9935,14.70577 66.8256,15.25491 L51.0055704,67 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-Y",
    d: "M57.0348687,75 L53.963149,75 L69.7889,23.23642 C69.9502,22.70872 69.645,22.1279 69.1003,21.96138 L24.8787,8.44147 C24.3349,8.27521 23.7592,8.57582 23.5949,9.11349 L3.6943,74.2052687 C3.61111141,74.4774257 3.65200529,74.7637086 3.78584197,75 L0.720999674,75 L22.7399,2.97929 C23.3866,0.86392 25.6244,-0.32706 27.7397,0.31965 L71.5822,13.72365 C73.6968,14.37014 74.8884,16.60347 74.24,18.72445 L57.0348687,75 L57.0348687,75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-aa",
    d: "M0.9888,1.49465 C1.1174,1.07392 1.5647,0.83771 1.9797,0.96459 L10.7719,3.65265 C11.1906,3.78064 11.4265,4.22253 11.297,4.64619 C11.1684,5.06693 10.7211,5.30314 10.3061,5.17626 L1.5139,2.4882 C1.0953,2.36021 0.8593,1.91832 0.9888,1.49465 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-ac",
    d: "M4.0569,2.22753 C3.7979,3.07487 2.9082,3.54237 2.0659,3.28483 L1.9927,3.26245 C1.1452,3.00335 0.676,2.11399 0.9332,1.27252 C1.1923,0.42519 2.0819,-0.04231 2.9243,0.21523 L2.9975,0.23761 C3.8449,0.4967 4.3142,1.38607 4.0569,2.22753 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-ae",
    d: "M1.4343,1.50851 C1.3306,1.84744 0.9748,2.03444 0.6378,1.93143 L0.6086,1.92248 C0.2634,1.81696 0.0819,1.46309 0.1848,1.12651 C0.2884,0.78757 0.6443,0.60057 0.9812,0.70359 L1.0105,0.71254 C1.3556,0.81805 1.5372,1.17192 1.4343,1.50851 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-ag",
    d: "M0.2636,19.08019 L5.8802,0.70902 L24.2514,6.32565 L18.6347,24.696822 L0.2636,19.08019 Z M8.4309,5.50666 L5.0696,16.50089 L16.0924,19.87089 L19.4536,8.87666 L8.4309,5.50666 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-ai",
    points: "1.166 .333 4.84 1.456 3.716 5.131 .042 4.007"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-ak",
    points: "1.748 .41 5.423 1.534 4.299 5.208 .624 4.084"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-am",
    points: "3.842 5 2.161 5 .023 4.346 1.147 .672 4.822 1.796 3.842 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-ao",
    points: "19.499 8.617 20.622 4.942 24.297 6.065 24.297 6.066 20.927 17.088 9.903 13.718 11.027 10.044 7.353 8.921 3.983 19.943 .308 18.82 5.925 .448 16.948 3.819 15.825 7.493"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-aq",
    d: "M0.0034,19.03535 L5.6201,0.66383 L23.9913,6.28046 L18.3745,24.65198 L0.0034,19.03535 Z M8.1709,5.46112 L4.8009,16.48389 L15.8236,19.85389 L19.1936,8.83112 L8.1709,5.46112 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-as",
    points: "1.844 .489 5.518 1.612 4.395 5.287 .721 4.163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-au",
    d: "M5.6649,0.40362 L24.0368,6.02046 L18.4201,24.39198 L0.0482,18.77514 L5.6649,0.40362 Z M15.8688,19.59378 L19.2388,8.57101 L8.2164,5.20112 L4.8464,16.22389 L15.8688,19.59378 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-aw",
    points: "1.688 .167 5.363 1.291 4.239 4.965 .565 3.842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-ay",
    d: "M1.81982,6.63654 C0.90273,6.11881 0.69672,5.11913 0.75027,4.68297 C0.81878,4.12504 0.90772,3.4007 2.51865,3.07786 C4.12959,2.75501 5.14339,3.66045 9.13925,3.1098 C13.16322,2.55528 16.72763,0.39705 17.43863,1.00499 C18.14964,1.61294 15.59951,4.9443 8.88012,6.72247 C6.79083,7.27536 3.1363,7.37973 1.81982,6.63654 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-aA",
    d: "M1.9533,3.89561 C4.4484,0.4615 9.2724,-0.30642 12.7167,2.19605 L15.6313,4.31357 C19.0812,6.82012 19.8411,11.634272 17.341,15.075387 C14.8459,18.5095 10.0219,19.2774231 6.5775,16.774951 L3.663,14.657428 C0.2131,12.150875 -0.5468,7.33673 1.9533,3.89561 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-aC",
    d: "M2.0353,3.23267 C4.5304,-0.20144 9.3544,-0.96937 12.7988,1.53311 L15.7133,3.65063 C19.1633,6.15718 19.9231,10.97133 17.423,14.41245 C14.928,17.84656 10.1039,18.61448 6.6596,16.11201 L3.745,13.99449 C0.2951,11.48793 -0.4648,6.67379 2.0353,3.23267 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-aE",
    d: "M79.2218487,52 L5.52118783,52 L1.01249,15.27962 C0.60916,11.99472 2.94944,9.00429 6.24281,8.59992 L72.1351,0.50937 C75.427,0.10516 78.4232,2.44463 78.826,5.72532 L83.7047,45.459782 C84.0768476,48.4901883 82.1139497,51.2699885 79.2218487,52 L79.2218487,52 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-aG",
    d: "M9.39196,0.8431 C12.77876,0.42725 15.81422,2.46539 16.33289,6.6896 C16.85096,10.90891 14.52592,14.65673 11.13912,15.07258 C7.75362,15.48826 4.59226,12.41409 4.07419,8.19478 C3.55438,3.97195 6.00646,1.25878 9.39196,0.8431 Z M0.01489,32.6726 L0.68185,22.84302 C0.84246,19.8625 6.54449,18.11089 11.37889,17.5173 C16.26245,16.91767 22.27589,17.25315 23.14005,20.17364 L25.95272,29.487835 L0.01489,32.6726 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-aI",
    d: "M13.6147015,16 L3.84878925,16 C3.15501497,15.4452945 2.54668815,14.7606084 2.0632,13.955948 C-0.12749,10.310028 1.04904,5.58042 4.70435,3.38409 L7.79233,1.52865 C11.44169,-0.66411 16.18043,0.52134 18.36667,4.15984 C20.55736,7.805756 19.38083,12.535361 15.72552,14.73169 L13.6147015,16 L13.6147015,16 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-aK",
    d: "M1.35368,14.4134 C-0.83701,10.76748 0.33952,6.03788 3.99482,3.84155 L7.08281,1.9861 C10.73216,-0.20666 15.47091,0.97879 17.65714,4.61729 C19.84783,8.26321 18.6713,12.99281 15.016,15.18914 L11.92801,17.04459 C8.27866,19.23734 3.53991,18.0519 1.35368,14.4134 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-aM",
    points: ".393 4.067 27.974 .68 28.582 5.635 1.002 9.021"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-aO",
    points: ".61 3.976 28.19 .589 28.799 5.544 1.218 8.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "basic-onboarding-aQ",
    points: ".827 3.885 28.407 .498 29.015 5.453 1.435 8.839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-aS",
    d: "M5.50041,11.53215 C2.51181,11.53215 0.08908,9.12388 0.08908,6.15312 C0.08908,3.18237 2.51181,0.7741 5.50041,0.7741 C8.489,0.7741 10.91173,3.18237 10.91173,6.15312 C10.91173,9.12388 8.489,11.53215 5.50041,11.53215 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "basic-onboarding-aU",
    d: "M5.4293,11.53215 C2.4407,11.53215 0.018,9.12388 0.018,6.15312 C0.018,3.18237 2.4407,0.7741 5.4293,0.7741 C8.4179,0.7741 10.8406,3.18237 10.8406,6.15312 C10.8406,9.12388 8.4179,11.53215 5.4293,11.53215 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 80)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-a"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDC69",
    points: "-4.379 -4.613 138.85 -4.613 138.85 117.925 -4.379 117.925",
    mask: "url(#basic-onboarding-b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168 80)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-c"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3CE55",
    points: "-4.276 -4.613 98.85 -4.613 98.85 114.697 -4.276 114.697",
    mask: "url(#basic-onboarding-d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(188 121)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-e"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-4.945 -4.064 12.347 -4.064 12.347 9.69 -4.945 9.69",
    mask: "url(#basic-onboarding-f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183 121)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-g"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-4.884 -4.064 12.408 -4.064 12.408 9.69 -4.884 9.69",
    mask: "url(#basic-onboarding-h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(195 121)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-i"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-4.042 -4.064 13.25 -4.064 13.25 9.69 -4.042 9.69",
    mask: "url(#basic-onboarding-j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 121)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-k"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-4.103 -4.064 13.189 -4.064 13.189 9.69 -4.103 9.69",
    mask: "url(#basic-onboarding-l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(182 103)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-m"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-4.378 -4.405 32.944 -4.405 32.944 23.044 -4.378 23.044",
    mask: "url(#basic-onboarding-n)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120 75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-o"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C4C4D",
    points: "-4.25 -4.935 155.041 -4.935 155.041 23.314 -4.25 23.314",
    mask: "url(#basic-onboarding-p)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192 75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-q"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillOpacity: 0.107,
    points: "-4.635 23.314 83.041 23.314 83.041 -4.935 -4.635 -4.935",
    mask: "url(#basic-onboarding-r)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(165 139)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-s"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C5E6EA",
    points: "-4.314 -4.302 64.785 -4.302 64.785 58.925 -4.314 58.925",
    mask: "url(#basic-onboarding-t)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194 139)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-u"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C4C4D",
    points: "-4.522 -4.302 6.993 -4.302 6.993 58.925 -4.522 58.925",
    mask: "url(#basic-onboarding-v)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(165 139)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-w"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillOpacity: 0.234,
    points: "-4.314 -4.302 43.57 -4.302 43.57 58.925 -4.314 58.925",
    mask: "url(#basic-onboarding-x)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 155)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-y"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEA62F",
    points: "-4.419 -4.407 130.877 -4.407 130.877 95.299 -4.419 95.299",
    mask: "url(#basic-onboarding-z)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71 142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-A"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ECD4C6",
    points: "-4.301 -4.697 30.758 -4.697 30.758 34.3 -4.301 34.3",
    mask: "url(#basic-onboarding-B)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-C"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5DFD0",
    points: "-4.609 -4.605 120.646 -4.605 120.646 121.385 -4.609 121.385",
    mask: "url(#basic-onboarding-D)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-E"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#965232",
    points: "-4.66 -4.9 147.854 -4.9 147.854 138.807 -4.66 138.807",
    mask: "url(#basic-onboarding-F)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-G"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5DFD0",
    points: "-4.609 -4.605 120.646 -4.605 120.646 121.385 -4.609 121.385",
    mask: "url(#basic-onboarding-H)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60 38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-I"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6CBBA",
    points: "-4.315 -4.605 88.646 -4.605 88.646 118.716 -4.315 118.716",
    mask: "url(#basic-onboarding-J)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-L",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-K"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A45938",
    points: "-4.054 -4.866 137.953 -4.866 137.953 112.734 -4.054 112.734",
    mask: "url(#basic-onboarding-L)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(54 83)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ECBDAA",
    strokeWidth: 2,
    d: "M35.22029,24.66679 C35.22029,27.335932 32.353554,29.4997 28.817255,29.4997 C25.280956,29.4997 22.41422,27.335932 22.41422,24.66679"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AC6444",
    strokeWidth: 3,
    d: "M11.8866535.83170766C7.60931122-.896450733 2.72335727 1.21346807.973569842 5.54434406M45.1253865.83170766C49.4027288-.896450733 54.2886827 1.21346807 56.0384702 5.54434406"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57 88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-N",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-M"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-4.293 -4.58 17.964 -4.58 17.964 17.311 -4.293 17.311",
    mask: "url(#basic-onboarding-N)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57 88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-O"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-4.293 -4.58 17.964 -4.58 17.964 17.311 -4.293 17.311",
    mask: "url(#basic-onboarding-P)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 91)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-R",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-Q"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "-4.17 -4.85 8.587 -4.85 8.587 7.825 -4.17 7.825",
    mask: "url(#basic-onboarding-R)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94 88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-T",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-S"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-4.545 -4.58 17.711 -4.58 17.711 17.751 -4.545 17.751",
    mask: "url(#basic-onboarding-T)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101 91)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-V",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-U"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "-4.422 -4.749 8.335 -4.749 8.335 8.026 -4.422 8.026",
    mask: "url(#basic-onboarding-V)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107 148)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-X",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-W"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F3F3F3",
    points: "17.575 -6.103 73.369 10.955 49.809 88.014 -5.984 70.956",
    mask: "url(#basic-onboarding-X)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104 140)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-Z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-Y"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C4C4D",
    points: "20.591 -7.094 81.654 11.575 52.272 107.679 -8.791 89.01",
    mask: "url(#basic-onboarding-Z)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(146 149)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-ab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aa"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5F5F5F",
    points: "-2.098 -5.511 17.773 .565 14.384 11.651 -5.487 5.576",
    mask: "url(#basic-onboarding-ab)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171 157)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-ad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-ac"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5F5F5F",
    points: "10.766 -2.616 -1.921 -6.494 -5.776 6.116 6.911 9.995",
    mask: "url(#basic-onboarding-ad)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168 156)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-af",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-ae"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5F5F5F",
    points: "7.864 -2.421 -2.949 -5.726 -6.245 5.056 4.568 8.361",
    mask: "url(#basic-onboarding-af)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114 184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-ah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-ag"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "2.561 -5.534 30.495 3.006 21.954 30.94 -5.98 22.4",
    mask: "url(#basic-onboarding-ah)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124 194)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-ai"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-2.154 -5.91 11.083 -1.864 7.036 11.374 -6.201 7.327",
    mask: "url(#basic-onboarding-aj)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143 208)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-al",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-ak"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-1.572 -5.833 11.666 -1.786 7.619 11.451 -5.619 7.404",
    mask: "url(#basic-onboarding-al)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151 210)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-an",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-am"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-2.173 -5.571 11.065 -1.524 7.018 11.713 -6.22 7.666",
    mask: "url(#basic-onboarding-an)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(136 191)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-ap",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-ao"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "2.606 -5.795 30.54 2.746 22 30.68 -5.935 22.14",
    mask: "url(#basic-onboarding-ap)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121 162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-ar",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aq"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "2.3 -5.58 30.235 2.961 21.694 30.895 -6.24 22.355",
    mask: "url(#basic-onboarding-ar)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 172)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-at",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-as"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-1.476 -5.755 11.762 -1.708 7.715 11.53 -5.523 7.483",
    mask: "url(#basic-onboarding-at)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143 169)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-av",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-au"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "2.345 -5.84 30.28 2.701 21.74 30.635 -6.195 22.095",
    mask: "url(#basic-onboarding-av)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152 179)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-ax",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aw"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "-1.631 -6.076 11.606 -2.029 7.559 11.209 -5.679 7.161",
    mask: "url(#basic-onboarding-ax)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77 129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-az",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-ay"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E17B7C",
    points: "-2.902 -6.598 23.172 -3.397 21.002 14.271 -5.071 11.069",
    mask: "url(#basic-onboarding-az)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156 195)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aA"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5DFD0",
    points: "-9.557 11.232 13.92 28.29 28.852 7.739 5.374 -9.319",
    mask: "url(#basic-onboarding-aB)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159 178)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aC"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5DFD0",
    points: "-9.476 10.57 14.002 27.627 28.934 7.076 5.456 -9.982",
    mask: "url(#basic-onboarding-aD)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29 163)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aE"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E7E5CE",
    points: "-5.29 4.978 82.449 -5.795 90.007 55.761 2.268 66.534",
    mask: "url(#basic-onboarding-aF)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42 179)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aG"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C4C4D",
    points: "-9.268 -1.903 26.595 -6.307 31.525 33.841 -4.338 38.245",
    mask: "url(#basic-onboarding-aH)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 199)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aI"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5DFD0",
    points: "-8.764 5.644 16.111 -9.303 29.194 12.472 4.319 27.419",
    mask: "url(#basic-onboarding-aJ)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 181)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aK"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F5DFD0",
    points: "-9.474 6.101 15.401 -8.845 28.485 12.929 3.61 27.876",
    mask: "url(#basic-onboarding-aL)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 176)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aM"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C4C4D",
    points: "-5.179 -.287 32.327 -4.892 34.154 9.988 -3.352 14.593",
    mask: "url(#basic-onboarding-aN)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71 186)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aO"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C4C4D",
    points: "-4.962 -.378 32.544 -4.983 34.371 9.897 -3.135 14.502",
    mask: "url(#basic-onboarding-aP)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72 196)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aQ"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4C4C4D",
    points: "-4.745 -.469 32.76 -5.074 34.587 9.806 -2.918 14.411",
    mask: "url(#basic-onboarding-aR)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54 113)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aS"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E17B7C",
    fillOpacity: 0.178,
    points: "-4.911 -4.226 15.912 -4.226 15.912 16.532 -4.911 16.532",
    mask: "url(#basic-onboarding-aT)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102 113)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "basic-onboarding-aV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#basic-onboarding-aU"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E17B7C",
    fillOpacity: 0.178,
    points: "-4.982 -4.226 15.841 -4.226 15.841 16.532 -4.982 16.532",
    mask: "url(#basic-onboarding-aV)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicOnboarding);
export default __webpack_public_path__ + "static/media/basic-onboarding.d9a85f748969e484b76a736c7e223630.svg";
export { ForwardRef as ReactComponent };